<template>

    <div class="f-item" :style="showcell?'':'zIndex:0'" v-if="!(type=='see' && !fieldModel)">
        <div class="van-overlay" v-if="showcell" @click="onCancel"></div>
        <div class="f-item" :style="showcell?'':'zIndex:0'" >
            <van-field
                    v-model="fieldModel"
                    name="fieldModel"
                    :label="label"
                    autocomplete="off"
                    :placeholder="type=='see'?'':'请选择'+label"
                    :readonly="type=='see'"
                    @input="onchange"
                    :rules="[{ required: false}]"
            />
            <van-list v-model="loading" :finished="finish" class="list-pop" v-if="showcell">
                <van-cell v-for="item in lists" :key="item.ID" :title="item.LABEL_NAME"
                          @click="clickcell(item)"
                >
                </van-cell>
            </van-list>
        </div>

    </div>

</template>

<script>
    import common from '@/api/common';

    export default {
        name: "intelligent",
        props: {
            label: String,
            type: String,
            required: Boolean,
            sVal: String,
            moduleId: Number
        },
        watch: {
            sVal() {
                if (this.$props.sVal) {
                    this.fieldModel = this.$props.sVal
                }
            }
        },
        data() {
            return {
                fieldModel: '', // 用于在输入框显示 label的值
                multipleArr: [], // 多选选中的值的数组
                multipleVal: '',
                lists: [], // 原始数据

                loading: false,
                finish: true,
                showcell: false,
            }
        },
        methods: {
            clickcell(item) {
                // this.productline = item.LABEL_NAME;
                // this.productVal = item.ID;
                this.fieldModel = item.LABEL_NAME;
                this.showcell = false;
                let productVal = item.ID;
                this.$emit('confirm', productVal)
            },
            onchange() {
                // console.log("onchangePro")
                // console.log(this.productline)
                if (this.fieldModel.length > 0) {
                    this.entityInligencePrompt(this.fieldModel)
                } else {
                    this.showcell = false;
                    this.lists = []
                    this.$emit('onCancel')
                }
            },
            onCancel(){
                this.showcell = false;
                this.lists = []
                this.$emit('onCancel')
            },
            // 智能搜索
            entityInligencePrompt(columsVal) {
                if (this.type == 'see') {
                    return
                }
                // let moduleId = this.CoreNew.SYSTABLE.PRO_LINE;
                common.entityInligencePrompt(this.$props.moduleId, columsVal).then(res => {
                    if (res && res.flag && res.data.length > 0) {
                        let data = res.data;
                        this.showcell = true;
                        this.lists = data;
                    } else {
                        this.showcell = false;
                        this.lists = []
                    }
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .f-item {
        position: relative;
        z-index: 1000;
        .van-cell {
            font-size: 14px;
            padding: 10px 16px;
        }
        .list-pop{
            max-height: 178px;
            overflow-y: auto;
        }

    }

</style>